import { axiosConfig } from "@/utils/axiosConfig";
import { omniAxios } from "@/utils/axios";

export function restCaptchaGet(params) {
  return omniAxios({
    url: axiosConfig.apiUserCaptchaGetPath,
    method: "post",
    apiType: axiosConfig.API_TYPE.USER,
    withCredentials: true,
    params,
  });
}

export function restCaptchaCheck(params) {
  return omniAxios({
    url: axiosConfig.apiUserCaptchaCheckPath,
    method: "post",
    apiType: axiosConfig.API_TYPE.USER,
    withCredentials: true,
    params,
  });
}

export function restCaptchaNoLoginCheck(params) {
  return omniAxios({
    url: axiosConfig.apiUserCaptchaNoLoginCheckPath,
    method: "post",
    apiType: axiosConfig.API_TYPE.USER,
    withCredentials: true,
    params,
  });
}
